import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'simpleMd'
})
export class SimpleMdPipe implements PipeTransform {

	transform(value: any, ...args: any[]): any {
		if (!value || typeof value !== 'string') {
			return '';
		}
		const replaceStr = args.length && args[0] === 'plaintext' ? '$1$2$3' : '$1<em>$2</em>$3';
		return value.replace(/(^|\W)_((?=[^\W_]).*?[^\W_])_($|\W)/g, replaceStr);
	}

}
